import {
  Box,
  Card,
  Checkbox,
  getSpacing,
  Grid,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { AprResource, AprSection as AprSectionModel } from "generated/openApi";
import "moment-timezone";
import { AprSection } from "./AprSection";
import { useEffect } from "react";

export const AprSections = (props: {
  selectedSectionItemIds: number[];
  setSelectedSectionItemIds: (value: number[]) => void;
  aprSections: AprSectionModel[];
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

  // get all the section item ids using flat map
  const allSectionItemIds = props.aprSections?.flatMap((x) => x.items?.map((y) => y.id) || []) || [];
  const allSelected = props.selectedSectionItemIds.length === allSectionItemIds.length;
  const someSelected = props.selectedSectionItemIds.length > 0 && !allSelected;

  return (
    <Card>
      <Checkbox
        label={
          <Typography fontSize="1.15rem" fontWeight={(theme) => theme.typography.fontWeightRegular}>
            All Sections
          </Typography>
        }
        checked={allSelected}
        indeterminate={someSelected}
        onChange={() => {
          if (allSelected) {
            props.setSelectedSectionItemIds([]);
          } else {
            props.setSelectedSectionItemIds(allSectionItemIds);
          }
        }}
      />

      <Box pl={getSpacing("md")}>
        <Grid ref={breakpointsRef} container spacing="sm">
          {props.aprSections.map((section) => {
            const sectionItemIds = section.items?.map((x) => x.id);

            return (
              <Grid item xs={setBreakpoints({ lg: 3, md: 6, xs: 12 })}>
                <AprSection
                  section={section}
                  selectedSectionItemIds={props.selectedSectionItemIds.filter((x) => sectionItemIds?.includes(x))}
                  setSelectedSectionItemIds={(value) => {
                    let selectedSectionItemIds = props.selectedSectionItemIds.filter(
                      (x) => !sectionItemIds?.includes(x)
                    );
                    selectedSectionItemIds = [...selectedSectionItemIds, ...value];
                    props.setSelectedSectionItemIds(selectedSectionItemIds);
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>

      {/* <pre>{JSON.stringify(props.selectedSectionItemIds, null, 4)}</pre> */}
    </Card>
  );
};
